/* XS-AV-Insurance-05 */
<template>
  <div>
    <mobialis-form-with-validation @onValidate="continueForm" v-slot="{ invalid, errors }">
      <Hero :title="$t('message.hero.additionalQuestions')" :text="$t('message.hero.additionalQuestionsText')"></Hero>
      <mobialis-text-input-with-validation
        rules="required"
        :label="$t('message.insurance.application.askVehiclePrice')"
        v-model="vehiclePrice"
        vid="vehiclePrice"
        placeholder="$"
        mask-type="money"
        data-cy="vehiclePrice"
        class="mb-4"
      >
        <a
          slot="icon"
          v-on:click="populateTooltip('vehiclePrice')"
          data-toggle="modal"
          data-target="#tooltip"
          role="button"
          >&nbsp; <img src="@/assets/question-circle.svg" :alt="tooltipAlt"
        /></a>
      </mobialis-text-input-with-validation>
      <div v-if="isAVRDesktop">
        <mobialis-selection-input-with-validation
          rules="required"
          :label="$t('message.insurance.application.winterTires')"
          v-model="winterTires"
          vid="winterTires"
          :placeHolder="$t('message.insurance.application.chooseWinterTires')"
          :options="winterTiresOptions"
          data-cy="winterTiresDesktop"
          class="mb-4"
        >
          <a
            slot="icon"
            v-on:click="populateTooltip('winterTires')"
            data-toggle="modal"
            data-target="#tooltip"
            role="button"
            >&nbsp; <img src="@/assets/question-circle.svg" :alt="tooltipAlt"
          /></a>
        </mobialis-selection-input-with-validation>
      </div>
      <div v-else>
        <label>{{ $t('message.insurance.application.winterTires') }}</label>
        <a v-on:click="populateTooltip('winterTires')" data-toggle="modal" data-target="#tooltip" role="button"
          >&nbsp; <img src="@/assets/question-circle.svg" :alt="tooltipAlt"
        /></a>
        <p v-if="errors['winterTiresMobile'] && errors['winterTiresMobile'][0]" class="error">
          {{ errors['winterTiresMobile'][0] }}
        </p>
        <MobialisFancyRadio
          class="mb-3"
          :textArray="[$t('message.common.yes'), $t('message.common.no')]"
          vid="winterTiresMobile"
          v-model="winterTires"
          name="Winter tires"
          data-cy="winterTiresMobile"
        ></MobialisFancyRadio>
      </div>
      <mobialis-text-input-with-validation
        v-if="countryCode === 'CA'"
        rules="required|length:6"
        :label="$t('message.common.postalCode')"
        v-model="postalCode"
        placeholder="A5A 5A5"
        vid="postalCode"
        mask-type="postalCode"
        data-cy="postalCode"
        class="mb-4"
      ></mobialis-text-input-with-validation>
      <mobialis-text-input-with-validation
        :rules="birthDateValidationRule"
        :label="$t('message.insurance.dateOfBirth')"
        v-model="birthdate"
        :helper="$t('message.credit.birthdayHelper')"
        vid="birthdate"
        mask-type="date"
        :raw="false"
        inputmode="numeric"
        data-cy="birthdate"
        class="mb-4"
      >
      </mobialis-text-input-with-validation>
      <div v-if="isAVRDesktop">
        <mobialis-selection-input-with-validation
          rules="required"
          :label="$t('message.insurance.application.gender')"
          v-model="gender"
          vid="gender"
          :placeHolder="$t('message.insurance.application.chooseGender')"
          :options="genderOptions"
          data-cy="genderDesktop"
          class="mb-4"
        >
        </mobialis-selection-input-with-validation>
      </div>
      <div v-else>
        <label>{{ $t('message.insurance.application.gender') }}</label>
        <p v-if="errors['genderMobile'] && errors['genderMobile'][0]" class="error">{{ errors['genderMobile'][0] }}</p>
        <MobialisFancyRadio
          class="mb-3"
          :textArray="[$t('message.common.male'), $t('message.common.female')]"
          vid="genderMobile"
          v-model="gender"
          name="Gender"
          data-cy="genderMobile"
        >
        </MobialisFancyRadio>
      </div>
      <div v-if="isAVRDesktop">
        <mobialis-selection-input-with-validation
          rules="required"
          :label="$t('message.insurance.application.maritalStatus')"
          v-model="maritalStatus"
          vid="maritalStatus"
          :placeHolder="$t('message.insurance.application.chooseMaritalStatus')"
          :options="maritalOptions"
          data-cy="maritalDesktop"
          class="mb-4"
        >
          <a v-on:click="populateTooltip('maritalStatus')" data-toggle="modal" data-target="#tooltip" role="button"
            >&nbsp; <img src="@/assets/question-circle.svg" :alt="tooltipAlt"
          /></a>
        </mobialis-selection-input-with-validation>
      </div>
      <div v-else>
        <label>{{ $t('message.insurance.application.maritalStatus') }}</label>
        <a
          slot="icon"
          v-on:click="populateTooltip('maritalStatus')"
          data-toggle="modal"
          data-target="#tooltip"
          role="button"
          >&nbsp; <img src="@/assets/question-circle.svg" :alt="tooltipAlt"
        /></a>
        <p v-if="errors['maritalStatusMobile'] && errors['maritalStatusMobile'][0]" class="error">
          {{ errors['maritalStatusMobile'][0] }}
        </p>
        <MobialisFancyRadio
          class="mb-3"
          :textArray="[
            $t('message.insurance.application.maritalOptions[0]'),
            $t('message.insurance.application.maritalOptions[1]'),
            $t('message.insurance.application.maritalOptions[2]'),
            $t('message.insurance.application.maritalOptions[3]'),
            $t('message.insurance.application.maritalOptions[4]'),
          ]"
          vid="maritalStatusMobile"
          v-model="maritalStatus"
          name="Marital status"
          data-cy="maritalMobile"
        ></MobialisFancyRadio>
      </div>
      <mobialis-text-input-with-validation
        rules="required"
        :label="$t('message.insurance.application.distanceDriven')"
        v-model="distanceDriven"
        vid="distanceDriven"
        :mask-type="languageCode === 'fr-CA' ? 'frenchInt' : 'int'"
        data-cy="mileage"
        class="mb-4"
      >
        <a
          slot="icon"
          v-on:click="populateTooltip('distanceDriven')"
          data-toggle="modal"
          data-target="#tooltip"
          role="button"
          >&nbsp; <img src="@/assets/question-circle.svg" :alt="tooltipAlt"
        /></a>
      </mobialis-text-input-with-validation>
      <mobialis-button type="submit" class="my-4" data-cy="submitAdditionalQuestions">{{
        $t('message.insurance.application.getQuotes')
      }}</mobialis-button>
    </mobialis-form-with-validation>
    <Modal :title="tooltipTitle" :body="tooltipBody"></Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';
import { enumMixin, formMixin } from '@/mixins';
import Hero from './hero/Hero.vue';
import Modal from './Modal.vue';

export default {
  name: 'AdditionalQuestions',
  mixins: [enumMixin, formMixin],
  components: { Hero, Modal },
  data() {
    return {
      answersArray: [],
      tooltipTitle: '',
      tooltipBody: '',
      winterTiresOptions: [this.$t('message.common.yes'), this.$t('message.common.no')],
      genderOptions: [this.$t('message.common.male'), this.$t('message.common.female')],
      maritalOptions: [
        this.$t('message.insurance.application.maritalOptions[0]'),
        this.$t('message.insurance.application.maritalOptions[1]'),
        this.$t('message.insurance.application.maritalOptions[2]'),
        this.$t('message.insurance.application.maritalOptions[3]'),
        this.$t('message.insurance.application.maritalOptions[4]'),
      ],
      tooltipAlt: this.$t('message.insurance.tooltips.tooltip'),
    };
  },
  mounted() {
    // Set a vehicle price if it's already set
    if (this.$route.query.purchasePrice) {
      this.$store.commit('insurance/SET_VEHICLE_PRICE', this.$route.query.purchasePrice);
    }
    this.$store.commit('SET_LOADING', false);
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }

      const loadingCommitKey = this.countryCode === 'US' ? 'insurance/SET_IS_QUOTE_LOADING' : 'SET_LOADING';
      this.$store.commit(loadingCommitKey, true);

      // Show the new loading screen for US flow
      if (this.countryCode === 'US') {
        this.$store.commit('insurance/SET_SHOW_QUOTE_LOADING', true);
      }

      try {
        await this.$store.dispatch('insurance/getQuote');
        // Update vehicle payload for leadUpdate
        this.$store.commit('insurance/SET_LEAD_INSURANCE_VEHICLE');
        try {
          await this.$store.dispatch('lead/updateLead', {
            step: this.enums.LeadStep.INSURANCE_REPORT,
          });

          this.$router.push('quotes');
        } catch (err) {
          if (this.countryCode === 'US') {
            this.$store.commit('insurance/SET_SHOW_QUOTE_LOADING', false);
          }
          log('Error in Insurance Additional Questions - Update Lead', err);
          this.$router.push({ name: `insurance-error-${this.baseRoute}` });
        } finally {
          this.$store.commit(loadingCommitKey, false);
        }
      } catch (err) {
        this.$store.commit(loadingCommitKey, false);
        if (this.countryCode === 'US') {
          this.$store.commit('insurance/SET_SHOW_QUOTE_LOADING', false);
        }
        log('Error in Insurance Additional Questions - Get quote', err);
        this.$router.push({ name: `insurance-error-${this.baseRoute}` });
      }
    },
    populateTooltip(value) {
      switch (value) {
        case 'vehiclePrice':
          this.populateTooltipHelper(value);
          break;
        case 'winterTires':
          this.populateTooltipHelper(value);
          break;
        case 'maritalStatus':
          this.populateTooltipHelper(value);
          break;
        case 'distanceDriven':
          this.populateTooltipHelper(value);
          break;
        default:
          this.tooltipTitle = '';
          this.tooltipBody = '';
      }
    },
    populateTooltipHelper(value) {
      this.tooltipTitle = this.$t(`message.insurance.tooltips.${value}`);
      this.tooltipBody = this.$t(`message.insurance.tooltips.${value}Tip`);
    },
  },
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    countryCode() {
      return this.$store.getters['business/getBusinessCountry'];
    },
    winterTires: {
      get() {
        return this.$store.state.insurance.insurance.hasWinterTires;
      },
      set(value) {
        this.$store.commit('insurance/SET_HAS_WINTER_TIRES', value.newValue || value);
      },
    },
    gender: {
      get() {
        return this.$store.state.insurance.insurance.gender;
      },
      set(value) {
        this.$store.commit('insurance/SET_GENDER', value.newValue || value);
      },
    },
    maritalStatus: {
      get() {
        return this.$store.state.insurance.insurance.maritalStatus;
      },
      set(value) {
        this.$store.commit('insurance/SET_MARITAL_STATUS', value.newValue || value);
      },
    },
    birthdate: {
      get() {
        return this.$store.state.user.birthdate;
      },
      set(value) {
        this.$store.commit('user/SET_BIRTHDATE', value);
      },
    },
    postalCode: {
      get() {
        return this.$store.state.user.postalCode;
      },
      set(value) {
        this.$store.commit('user/SET_POSTAL_CODE', value);
      },
    },
    vehiclePrice: {
      get() {
        return this.$store.state.insurance.insurance.price;
      },
      set(value) {
        this.$store.commit('insurance/SET_VEHICLE_PRICE', value);
      },
    },
    distanceDriven: {
      get() {
        return this.$store.state.insurance.insurance.distance;
      },
      set(value) {
        this.$store.commit('insurance/SET_ONE_WAY_DISTANCE', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  font-size: 14px;
  margin-top: 0;
  margin-bottom: 8px;
}
label {
  font-weight: 500;
  margin: 1.5px 0 0;
  line-height: 1.75;
}
</style>
